import _ from "lodash";
import { PortalType } from "../../../../Enums/ChoiceEnums";
import { IPatientFlagDisplayOrder, IPatientFlagPatientAssignItem } from "../../../../lib/Models/Setup/PatientFlagSetupModel";

export type IPatientFlagPatientAssignItemWithDisplayOrder = IPatientFlagPatientAssignItem & {displayOrder?: number};

// Return a sorted list of patient flags that should be displayed because they are active & assigned and sort the result
export function sortedAndVisiblePatientFlags(
            patientFlags: IPatientFlagPatientAssignItemWithDisplayOrder[] | undefined, 
            patientFlagDisplayOrderValues: IPatientFlagDisplayOrder[] | undefined,
            displayContext?: PortalType
    ): IPatientFlagPatientAssignItem[] | undefined
{
    // Add the display order
    const flagsWithDisplayOrder = patientFlags
                ?.filter(flg => showFlag(flg, displayContext))
                ?.map(flg => addDisplayOrder(flg, patientFlagDisplayOrderValues));

    return _.sortBy(flagsWithDisplayOrder, ["displayOrder", "longDescription"]);
}

function showFlag(flag: IPatientFlagPatientAssignItem, displayContext?: PortalType): boolean
{
    return flag.patientAssigned && 
            flag.active &&
            (
                (PortalType.Billing === displayContext && flag.billingPortalActive) ||
                (PortalType.Documents === displayContext && flag.documentPortalActive) ||
                (PortalType.Emr === displayContext && flag.emrPortalActive) ||
                (PortalType.Scheduler === displayContext && flag.schedulerPortalActive) ||
                (undefined === displayContext)
            );
}

function addDisplayOrder(flag: IPatientFlagPatientAssignItemWithDisplayOrder, patientFlagDisplayOrderValues?: IPatientFlagDisplayOrder[])
{
    flag.displayOrder = undefined;

    if (!patientFlagDisplayOrderValues)
        return flag;

    const displayOrderInfo = patientFlagDisplayOrderValues.find(item => item.flagSetupId === flag.flagSetupId);
    flag.displayOrder = displayOrderInfo?.displayOrder ?? 1000 * 1000 * 1000;        
    return flag;
}